// Settings, AMS360 (spec C13; the Manager and the Admin): the AMS360 web address every Open in
// AMS360 link starts with. A shared section, not Integrations, so the Manager can put in AMS360's
// new version after an AMS360 update without waiting for the Admin. AMS360's API keys stay out of
// here: they live only in 1Password and Railway.
import { useLoaderData } from 'react-router';
import type { AmsAddressView, Api } from '../auth/api';
import { AmsAddressCard } from '../settings/AmsAddressCard';
import { SettingsNav } from '../settings/SettingsNav';
import { PageHeader } from '../shell/PageHeader';

export type AmsSettingsLoaderData = AmsAddressView;

export function AmsSettingsPage({ api }: { api: Api }) {
  const view = useLoaderData() as AmsSettingsLoaderData;
  return (
    <>
      <PageHeader title="Settings" subtitle="Changes apply to everyone in the department" />
      <div className="setwrap">
        <SettingsNav current="/settings/ams360" />
        <div className="setcol">
          <h2 className="dtitle">AMS360</h2>
          <AmsAddressCard api={api} initial={view} />
        </div>
      </div>
    </>
  );
}
